import React, { useState } from 'react';

const contacts = [
  { id: 1, name: 'Jean Dupont', category: 'Famille' },
  { id: 2, name: 'Alice Mbappe', category: 'Amis' },
  { id: 3, name: 'Société X', category: 'Partenaires' },
];

const requests = [
  { id: 1, contact: 'Jean Dupont', type: 'Demande', amount: 100, status: 'En attente' },
  { id: 2, contact: 'Alice Mbappe', type: 'Transfert', amount: 50, status: 'Confirmé' },
];

export default function SendRequest() {
  const [selectedCategory, setSelectedCategory] = useState('Tous');

  const filteredContacts = selectedCategory === 'Tous'
    ? contacts
    : contacts.filter(c => c.category === selectedCategory);

  const handleAction = (type, contactName) => {
    alert(`${type} à ${contactName}`);
  };

  return (
    <div className="p-6 space-y-8">
      <h1 className="text-2xl font-bold">Envoyez ou demandez à vos contacts</h1>

      {/* Catégories */}
      <div className="flex gap-4">
        {['Tous', 'Famille', 'Amis', 'Partenaires'].map(cat => (
          <button
            key={cat}
            className={`px-4 py-2 rounded-md ${selectedCategory === cat ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Liste des contacts */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredContacts.map(contact => (
          <div key={contact.id} className="bg-white shadow rounded-lg p-4">
            <h3 className="font-semibold text-lg">{contact.name}</h3>
            <p className="text-sm text-gray-500 mb-4">{contact.category}</p>
            <div className="flex gap-2">
              <button
                className="flex-1 bg-green-600 text-white px-3 py-2 rounded-md text-sm hover:bg-green-700"
                onClick={() => handleAction('Transfert', contact.name)}
              >
                Envoyer de l'argent
              </button>
              <button
                className="flex-1 bg-yellow-500 text-white px-3 py-2 rounded-md text-sm hover:bg-yellow-600"
                onClick={() => handleAction('Demande', contact.name)}
              >
                Faire une demande
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Historique des demandes */}
      <div>
        <h2 className="text-xl font-semibold mb-4">Historique des demandes</h2>
        <table className="w-full text-sm bg-white rounded shadow overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-left p-2">Contact</th>
              <th className="text-left p-2">Type</th>
              <th className="text-left p-2">Montant</th>
              <th className="text-left p-2">Statut</th>
            </tr>
          </thead>
          <tbody>
            {requests.map(req => (
              <tr key={req.id} className="border-t">
                <td className="p-2">{req.contact}</td>
                <td className="p-2">{req.type}</td>
                <td className="p-2">{req.amount} USD</td>
                <td className="p-2">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${
                    req.status === 'Confirmé' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-800'
                  }`}>
                    {req.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
